import { store } from '../../appContainer/AppContainer';
import { SnackbarHandlerSchema } from '../errorHandler.types';
import { logoutUserAction, publishErrorAction } from '../../appContainer/actions';

export const successResponseHandler = response => {
  const { data, status } = response;
  const { context, success, message } = data;

  if (!success) {
    const errorObj = new SnackbarHandlerSchema(status, message || 'Request Failed');
    store.dispatch(publishErrorAction.Trigger(errorObj));
  }

  return {
    context,
    status,
    success,
    message,
  };
};

export const errorResponseHandler = error => {
  if (!error.response) {
    return { context: {}, status: 0, success: false, message: 'Check your Internet' };
  }
  const { response } = error || {};
  const { data, status } = response || {};

  if (response.status === 401) {
    store.dispatch(logoutUserAction.Request());
  }

  const errorObj = new SnackbarHandlerSchema(status, data.message || 'Request Failed');
  store.dispatch(publishErrorAction.Trigger(errorObj));

  return {
    context: {
      token: data.token,
      refreshToken: data.token,
    },
    status: response.status,
    success: false,
    message: data.message || 'Sorry, something went wrong, Please try again',
  };
};
